module.exports = __webpack_public_path__ + "img/2712088c0faf8a7430c0351f315c0953.svg";